import { CardData, CardSlot, CardModifier } from '../types';

let cardIdCounter = 0;

interface CreateCardOptions {
  kind?: 'number' | 'curse';
  curseId?: string;
  curseName?: string;
  curseText?: string;
}

export function createCard(
  number: number,
  modifiers: CardModifier[] = [],
  options?: CreateCardOptions,
): CardData {
  return {
    id: `card_${++cardIdCounter}`,
    number,
    slot: 'hand',
    modifiers,
    permanentExhaust: false,
    kind: options?.kind ?? 'number',
    curseId: options?.curseId,
    curseName: options?.curseName,
    curseText: options?.curseText,
  };
}

export function resetCardIds(): void {
  cardIdCounter = 0;
}

export function getCardColor(slot: CardSlot): number {
  switch (slot) {
    case 'attack': return 0xc62828;
    case 'defense': return 0x1565c0;
    case 'ability': return 0x2e7d32;
    default: return 0x2d2d44;
  }
}
